import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../i18n/language.service';

@Component({
  selector: 'app-page3',
  standalone: false,
  templateUrl: './page3.component.html',
  styleUrls: ['./page3.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Page3Component {
  constructor(public language: LanguageService) {}
}
